import * as React from 'react'
import { cn } from '../../lib/utils'

export type PageHeaderProps = Omit<React.HTMLAttributes<HTMLElement>, 'title'> & {
  title: React.ReactNode
  description?: React.ReactNode
  metadata?: React.ReactNode
  actions?: React.ReactNode
}

export const PageHeader = React.forwardRef<HTMLElement, PageHeaderProps>(
  ({ title, description, metadata, actions, className, ...props }, ref) => (
    <header
      ref={ref}
      className={cn(
        'flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between',
        className,
      )}
      {...props}
    >
      <div className="min-w-0">
        <h1 className="m-0 text-[length:var(--page-title-size)] font-[var(--page-title-weight)] leading-[var(--page-title-line-height)] text-[var(--color-text)]">
          {title}
        </h1>
        {description && (
          <div className="mt-1 max-w-[var(--page-description-max)] text-[length:var(--page-description-size)] leading-[var(--page-description-line-height)] text-[var(--color-text-muted)]">
            {description}
          </div>
        )}
        {metadata && (
          <div className="mt-2 text-[length:var(--page-metadata-size)] text-[var(--color-text-muted)]">
            {metadata}
          </div>
        )}
      </div>
      {actions && (
        <div className="flex shrink-0 flex-wrap items-center gap-2 xl:justify-end">
          {actions}
        </div>
      )}
    </header>
  ),
)
PageHeader.displayName = 'PageHeader'
